import React from "react";

import { createSnackbar } from "utils/createSnackbar";

import instance from "api/v1";
import { useAuth } from "hooks/useAuth";

export function useDeleteHomeMeta() {
  // @ts-ignore
  const { user } = useAuth();
  const apiInstance = instance(user);

  return React.useCallback(
    (homeMetaId: number, homeMeta: [], setHomeMeta: any) => {
      const fetch = async () => {
        await apiInstance
          .delete(`/general-pages/${homeMetaId}`)
          .then(() => {
            createSnackbar("Home meta tags deleted successfully");
            setHomeMeta(homeMeta.filter((item: any) => item.id !== homeMetaId));
          })
          .catch((error) => {
            console.error(error);
            if (error.response) createSnackbar(error.response.data.message);
            else createSnackbar("Something went wrong");
          });
      };
      fetch();
    },
    [],
  );
}
